import React from "react";

export default function ExcelIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <g clip-path="url(#clip0_795_5814)">
        <path
          d="M13.5981 0H15.3523V2.4186C18.3084 2.4186 21.2644 2.42465 24.2203 2.40941C24.7195 2.43046 25.2688 2.39442 25.7028 2.69965C26.0069 3.14709 25.9717 3.71546 25.9922 4.22941C25.9776 9.47779 25.9835 14.7233 25.9865 19.9685C25.9719 20.8484 26.0662 21.7462 25.8861 22.614C25.768 23.2428 25.0297 23.2578 24.5364 23.2791C21.477 23.288 18.4148 23.273 15.3523 23.2791V26H13.5182C9.0177 25.1624 4.50817 24.3887 0.00195312 23.5814V2.42175C4.5351 1.61442 9.06802 0.819423 13.5981 0Z"
          fill="white"
        />
        <path
          d="M15.3521 3.32568H25.0973V22.3722H15.3521V20.5582H17.7145V18.442H15.3521V17.2327H17.7145V15.1164H15.3521V13.9071H17.7145V11.7908H15.3521V10.5815H17.7145V8.46522H15.3521V7.25592H17.7145V5.13964H15.3521V3.32568Z"
          fill="#686A97"
        />
        <path
          d="M18.896 5.13965H23.0304V7.25593H18.896V5.13965Z"
          fill="white"
        />
        <path
          d="M8.7492 7.97222C9.4166 7.92385 10.0871 7.88152 10.7573 7.84839C9.97004 9.50361 9.17568 11.1553 8.37427 12.8034C9.1865 14.4964 10.016 16.1773 10.831 17.8704C10.1201 17.8286 9.40946 17.7822 8.69911 17.7313C8.19708 16.4705 7.58567 15.2522 7.22539 13.9341C6.824 15.1615 6.25086 16.3193 5.79041 17.5228C5.14356 17.5136 4.49671 17.4865 3.8501 17.4592C4.60893 15.9386 5.3413 14.4057 6.12376 12.8941C5.45943 11.337 4.72989 9.81036 4.04477 8.26245C4.69445 8.22303 5.34414 8.18385 5.99382 8.14757C6.43372 9.32978 6.91496 10.4965 7.27855 11.709C7.66812 10.4242 8.25001 9.2149 8.7492 7.97222Z"
          fill="#686A97"
        />
        <path
          d="M18.896 8.46509H23.0304V10.5814H18.896V8.46509ZM18.896 11.7907H23.0304V13.9069H18.896V11.7907ZM18.896 15.1163H23.0304V17.2325H18.896V15.1163ZM18.896 18.4418H23.0304V20.5581H18.896V18.4418Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_795_5814">
          <rect width="26" height="26" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
